import { useEffect, useState } from "react";
import styled from "styled-components";
import { getLocale } from "react-i18nify";

import { Stack } from "@mui/material";

import Button from "src/components/core/Button";

import BottonSheet from "src/components/ui/BottonSheet";
import EditComponent from "./Edit";
import AddComponent from "./Add";

const WrapperContent = styled.div`
  width: 100%;
  overflow-y: auto;
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
`;

const ButtonGroup = styled(Stack)`
  flex: 0 0 auto;
  width: 100%;
  /* height: max-content; */
  background-color: #fff;
  z-index: 15;
  padding: 32px 24px;
`;

const BottomSheetDesc = ({
  type = "desc",
  descData = "",
  docType,
  dataSearch,
  setDataSearch,
  suggestDescList,
  setSuggestDescList,
  isOpen = false,
  isEdit,
  onClose,
  onSubmit,
}) => {
  const [editTextDesc, setEditTextDesc] = useState("");

  useEffect(() => {
    if (isOpen) {
      setEditTextDesc(descData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // const getDescText = async () => {
  //   let text = "";
  //   suggestDescList
  //     .filter((item) => item.isSelect === true)
  //     // eslint-disable-next-line array-callback-return
  //     .map((selected, i) => {
  //       if (text === "") text = `${selected?.description_text}`;
  //       else text = `${text}\n${selected?.description_text}`;
  //     });

  //   await setEditTextDesc(text);
  //   // await goToNextStep();

  //   // if (action === "submit") {
  //   //   reset();
  //   //   await onSubmit(text);
  //   // } else {
  //   //   setEditTextDesc(text);
  //   // }
  // };

  return (
    <>
      <BottonSheet
        title={type === "desc" ? `แนะนำรายละเอียดสินค้า` : `เพิ่มหมายเหตุสินค้า`}
        onClose={onClose}
        open={isOpen}
      >
        {isEdit ? (
          <>
            <WrapperContent>
              <Content>
                <EditComponent
                  type={type}
                  docType={docType}
                  textDesc={editTextDesc}
                  setTextDesc={setEditTextDesc}
                  suggestDescList={suggestDescList}
                  setSuggestDescList={setSuggestDescList}
                />
              </Content>
            </WrapperContent>

            <ButtonGroup
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              columnGap={2}
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => onSubmit(editTextDesc)}
                sx={{
                  width: "100%",
                  maxWidth: 350,
                  borderRadius: 4,
                  py: 1.5,
                }}
                disabled={type === "remark" && editTextDesc?.length > 400}
              >
                {getLocale() === "th" ? "ยืนยัน" : "Confirm"}
              </Button>
            </ButtonGroup>
          </>
        ) : (
          <>
            <WrapperContent>
              <Content>
                <AddComponent
                  type={type}
                  docType={docType}
                  dataSearch={dataSearch}
                  setDataSearch={setDataSearch}
                  suggestDescList={suggestDescList}
                  setSuggestDescList={setSuggestDescList}
                  textDesc={editTextDesc}
                  setTextDesc={setEditTextDesc}
                />
              </Content>
            </WrapperContent>

            <ButtonGroup
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              columnGap={2}
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => onSubmit(editTextDesc)}
                disabled={(type === "remark" && editTextDesc?.length > 400) || editTextDesc === ""}
                sx={{
                  width: "100%",
                  maxWidth: 160,
                  borderRadius: 4,
                  py: 1.5,
                }}
              >
                {getLocale() === "th" ? "ยืนยัน" : "Confirm"}
              </Button>
            </ButtonGroup>
          </>
        )}
      </BottonSheet>
    </>
  );
};

export default BottomSheetDesc;
